/* tslint:disable */
/* eslint-disable */
/**
 * Corrigo API
 * fejlesztői
 *
 * The version of the OpenAPI document: 1.5.2
 * Contact: kerezsigergely@infobex.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
/**
 *
 */
export class UserApi extends runtime.BaseAPI {
    /**
     *  [ID: CheckCredentialsAvailability]
     */
    checkCredentialsAvailabilityRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['username'] != null) {
                queryParameters['username'] = requestParameters['username'];
            }
            if (requestParameters['email'] != null) {
                queryParameters['email'] = requestParameters['email'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/users/register`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     *  [ID: CheckCredentialsAvailability]
     */
    checkCredentialsAvailability() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.checkCredentialsAvailabilityRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Identitás ellenőrzése [ID: CheckIdentity]
     */
    checkIdentityRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['token'] != null) {
                queryParameters['token'] = requestParameters['token'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/users/auth`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Identitás ellenőrzése [ID: CheckIdentity]
     */
    checkIdentity() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.checkIdentityRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     *  [ID: CreateApiToken]
     */
    createApiTokenRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['user_id'] == null) {
                throw new runtime.RequiredError('user_id', 'Required parameter "user_id" was null or undefined when calling createApiToken().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/users/{user_id}/api_tokens`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['user_id']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     *  [ID: CreateApiToken]
     */
    createApiToken(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createApiTokenRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     *  [ID: deprecated_CreateUser]
     * @deprecated
     */
    deprecatedCreateUserRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/users`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['CreateUserParams'],
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     *  [ID: deprecated_CreateUser]
     * @deprecated
     */
    deprecatedCreateUser() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.deprecatedCreateUserRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Felhasználók keresése metaadat alapján
     *  [ID: FindUsersByFormData]
     */
    findUsersByFormDataRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['approximate'] != null) {
                queryParameters['approximate'] = requestParameters['approximate'];
            }
            if (requestParameters['organization_id'] != null) {
                queryParameters['organization_id'] = requestParameters['organization_id'];
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/users/find`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['SearchParameter'],
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Felhasználók keresése metaadat alapján
     *  [ID: FindUsersByFormData]
     */
    findUsersByFormData() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.findUsersByFormDataRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     *  [ID: GetAccessLevelsForModel]
     * @deprecated
     */
    getAccessLevelsForModelRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['model_id'] == null) {
                throw new runtime.RequiredError('model_id', 'Required parameter "model_id" was null or undefined when calling getAccessLevelsForModel().');
            }
            const queryParameters = {};
            if (requestParameters['model_id'] != null) {
                queryParameters['model_id'] = requestParameters['model_id'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/users/permissions`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     *  [ID: GetAccessLevelsForModel]
     * @deprecated
     */
    getAccessLevelsForModel(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getAccessLevelsForModelRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Szervezetek lekérdezése [ID: GetOrganizationMemberships]
     */
    getOrganizationMembershipsRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/users/organizations`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Szervezetek lekérdezése [ID: GetOrganizationMemberships]
     */
    getOrganizationMemberships(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getOrganizationMembershipsRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Felhasználó lekérdezése ID alapján [ID: GetUserById]
     */
    getUserByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['user_id'] == null) {
                throw new runtime.RequiredError('user_id', 'Required parameter "user_id" was null or undefined when calling getUserById().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/users/{user_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['user_id']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Felhasználó lekérdezése ID alapján [ID: GetUserById]
     */
    getUserById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getUserByIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Felhasználók lekérdezése [ID: GetUsers]
     */
    getUsersRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['username'] != null) {
                queryParameters['username'] = requestParameters['username'];
            }
            if (requestParameters['email'] != null) {
                queryParameters['email'] = requestParameters['email'];
            }
            if (requestParameters['organization_id'] != null) {
                queryParameters['organization_id'] = requestParameters['organization_id'];
            }
            if (requestParameters['registered_after'] != null) {
                queryParameters['registered_after'] = requestParameters['registered_after'];
            }
            if (requestParameters['registered_before'] != null) {
                queryParameters['registered_before'] = requestParameters['registered_before'];
            }
            if (requestParameters['active_status'] != null) {
                queryParameters['active_status'] = requestParameters['active_status'];
            }
            if (requestParameters['login_name'] != null) {
                queryParameters['login_name'] = requestParameters['login_name'];
            }
            if (requestParameters['with_metadata'] != null) {
                queryParameters['with_metadata'] = requestParameters['with_metadata'];
            }
            if (requestParameters['exact'] != null) {
                queryParameters['exact'] = requestParameters['exact'];
            }
            if (requestParameters['approximate'] != null) {
                queryParameters['approximate'] = requestParameters['approximate'];
            }
            if (requestParameters['substring'] != null) {
                queryParameters['substring'] = requestParameters['substring'];
            }
            if (requestParameters['limit'] != null) {
                queryParameters['limit'] = requestParameters['limit'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/users`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Felhasználók lekérdezése [ID: GetUsers]
     */
    getUsers() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.getUsersRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Jelszó reset [ID: RequestPasswordReset]
     */
    requestPasswordResetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['RequestPasswordResetRequest'] == null) {
                throw new runtime.RequiredError('RequestPasswordResetRequest', 'Required parameter "RequestPasswordResetRequest" was null or undefined when calling requestPasswordReset().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/users/auth/reset_password`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['RequestPasswordResetRequest'],
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Jelszó reset [ID: RequestPasswordReset]
     */
    requestPasswordReset(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.requestPasswordResetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Új jelszó beállítása [ID: SetPassword]
     */
    setPasswordRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['SetPasswordRequest'] == null) {
                throw new runtime.RequiredError('SetPasswordRequest', 'Required parameter "SetPasswordRequest" was null or undefined when calling setPassword().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/users/auth`,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['SetPasswordRequest'],
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Új jelszó beállítása [ID: SetPassword]
     */
    setPassword(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.setPasswordRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Bejelentkezés [ID: SignIn]
     */
    signInRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/users/auth`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['SignInRequest'],
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Bejelentkezés [ID: SignIn]
     */
    signIn() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.signInRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Kijelentkezés [ID: SignOut]
     */
    signOutRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/users/auth`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Kijelentkezés [ID: SignOut]
     */
    signOut(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.signOutRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Felhasználó adatainak frissítése [ID: UpdateUser]
     */
    updateUserRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['user_id'] == null) {
                throw new runtime.RequiredError('user_id', 'Required parameter "user_id" was null or undefined when calling updateUser().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/users/{user_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['user_id']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['UpdateUserRequest'],
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Felhasználó adatainak frissítése [ID: UpdateUser]
     */
    updateUser(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateUserRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
